import SidebarDisclaimer from './SidebarDisclaimer';

export default SidebarDisclaimer;
